import { render, staticRenderFns } from "./HistoryProject.vue?vue&type=template&id=3a334418"
import script from "./HistoryProject.vue?vue&type=script&lang=js"
export * from "./HistoryProject.vue?vue&type=script&lang=js"
import style0 from "./HistoryProject.vue?vue&type=style&index=0&id=3a334418&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports